export const getLocalBusinessStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "MedicalClinic",
  "name": "Fizjofit - Gabinet Fizjoterapii i Rehabilitacji",
  "description": "Profesjonalna fizjoterapia i rehabilitacja w Reczu. Gabinet Fizjofit P.G. Pabich oferuje kompleksowe usługi fizjoterapeutyczne.",
  "url": "https://www.fizjoterapia-pabich.pl",
  "telephone": "+48661628174",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "ul. Piastowska 6",
    "addressLocality": "Recz",
    "postalCode": "73-210",
    "addressCountry": "PL"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 53.2594,
    "longitude": 15.5471
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "19:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "09:00",
      "closes": "13:00"
    }
  ],
  "priceRange": "$$",
  "paymentAccepted": ["Cash", "Credit Card"],
  "currenciesAccepted": "PLN",
  "image": "https://www.fizjoterapia-pabich.pl/img/logo_new.png",
  "logo": "https://www.fizjoterapia-pabich.pl/img/logo_new.png",
  "sameAs": [
    "https://www.facebook.com/fizjofit.pabich/"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Usługi Fizjoterapeutyczne",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Fizjoterapia",
          "description": "Kompleksowa fizjoterapia i rehabilitacja"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Masaż",
          "description": "Profesjonalne masaże lecznicze"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Terapia manualna",
          "description": "Leczenie bólów kręgosłupa i stawów"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Rehabilitacja pourazowa",
          "description": "Rehabilitacja po urazach i operacjach"
        }
      }
    ]
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Recz"
    },
    {
      "@type": "City", 
      "name": "Choszczno"
    },
    {
      "@type": "City",
      "name": "Barlinek"
    },
    {
      "@type": "City",
      "name": "Kalisz Pomorski"
    },
    {
      "@type": "City",
      "name": "Drawno"
    }
  ],
  "medicalSpecialty": [
    "Physiotherapy",
    "Rehabilitation",
    "Manual Therapy",
    "Sports Medicine"
  ]
});

export const getPersonStructuredData = (name: string, role: string) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "name": name,
  "jobTitle": role,
  "worksFor": {
    "@type": "Organization",
    "name": "Fizjofit - Gabinet Fizjoterapii i Rehabilitacji"
  },
  "telephone": "+48661628174",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "ul. Piastowska 6",
    "addressLocality": "Recz",
    "postalCode": "73-210",
    "addressCountry": "PL"
  },
  "knowsAbout": [
    "Fizjoterapia",
    "Rehabilitacja",
    "Terapia manualna",
    "Masaż leczniczy"
  ]
});

export const getBreadcrumbStructuredData = (breadcrumbs: Array<{name: string, item: string}>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.item
  }))
});

export const getChoszcznoLocalBusinessStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "MedicalClinic",
  "name": "Fizjoterapia Choszczno - Gabinet Fizjofit w pobliżu Choszczna",
  "description": "Profesjonalna fizjoterapia i rehabilitacja dla mieszkańców Choszczna. Gabinet Fizjofit w Reczu - 20 minut od Choszczna. Fizjoterapia neurologiczna, ortopedyczna, sportowa.",
  "url": "https://www.fizjoterapia-pabich.pl/fizjoterapia-choszczno",
  "telephone": "+48661628174",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "ul. Piastowska 6",
    "addressLocality": "Recz",
    "postalCode": "73-210",
    "addressCountry": "PL"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 53.2594,
    "longitude": 15.5471
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "19:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "09:00",
      "closes": "13:00"
    }
  ],
  "priceRange": "$$",
  "paymentAccepted": ["Cash", "Credit Card"],
  "currenciesAccepted": "PLN",
  "image": "https://www.fizjoterapia-pabich.pl/img/logo_new.png",
  "logo": "https://www.fizjoterapia-pabich.pl/img/logo_new.png",
  "sameAs": [
    "https://www.facebook.com/fizjofit.pabich/"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Usługi Fizjoterapeutyczne dla Choszczna",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Fizjoterapia neurologiczna Choszczno",
          "description": "Specjalistyczna rehabilitacja neurologiczna dla mieszkańców Choszczna"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Rehabilitacja ortopedyczna Choszczno",
          "description": "Kompleksowa rehabilitacja ortopedyczna w pobliżu Choszczna"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Masaż leczniczy Choszczno",
          "description": "Profesjonalne masaże dla mieszkańców Choszczna"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Terapia manualna Choszczno",
          "description": "Skuteczne leczenie kręgosłupa metodami manualnymi"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Fizjoterapia uroginekologiczna Choszczno",
          "description": "Specjalistyczna fizjoterapia uroginekologiczna dla kobiet"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Kinesiotaping Choszczno",
          "description": "Nowoczesne metody wspomagania rehabilitacji"
        }
      }
    ]
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Choszczno"
    },
    {
      "@type": "City",
      "name": "Recz"
    },
    {
      "@type": "City", 
      "name": "Barlinek"
    },
    {
      "@type": "City",
      "name": "Kalisz Pomorski"
    },
    {
      "@type": "City",
      "name": "Drawno"
    },
    {
      "@type": "City",
      "name": "Suchań"
    },
    {
      "@type": "City",
      "name": "Stargard"
    }
  ],
  "medicalSpecialty": [
    "Physiotherapy",
    "Neurological Rehabilitation",
    "Orthopedic Rehabilitation", 
    "Sports Medicine",
    "Manual Therapy",
    "Urogynecological Physiotherapy"
  ],
  "potentialAction": {
    "@type": "ReserveAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "tel:+48661628174"
    },
    "result": {
      "@type": "Reservation",
      "name": "Umówienie wizyty fizjoterapeutycznej"
    }
  }
});
